import { persist, getPersisted, removePersisted } from '../persist';

const KEY_PREFIX = 'error';

export const persistError = (store, type) => persist(`${KEY_PREFIX}.${store}`, type);
export const getPersistedError = store => getPersisted(`${KEY_PREFIX}.${store}`);
export const removePersistedError = store => removePersisted(`${KEY_PREFIX}.${store}`);
